import React from 'react';

const UpVoteIcon = () => (
  <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.105 11.7129L16.015 11.6034L9.215 3.44815C8.985 3.17196 8.64 3 8.255 3C7.87 3 7.525 3.17718 7.295 3.44815L0.5 11.5878L0.385 11.7233C0.3 11.8536 0.25 12.0099 0.25 12.1767C0.25 12.63 0.62 13 1.08 13H15.42C15.88 13 16.25 12.63 16.25 12.1767C16.25 12.0047 16.195 11.8431 16.105 11.7129Z'
      fill='#00FC92'
    />
  </svg>
);

export default UpVoteIcon;
